import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../images/logo/logo.svg";
import MegaMenu1 from "./MegaMenu1";
import MegaMenuServices from "./MegaMenu2";
import MegaMenuSolutions from "./MegaMenuSolutions";
import MobileMenu from "../MobileMenu/MobileMenu";

const Header: React.FC = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileActive, setMobileActive] = useState(false);
  const lastScrollY = useRef<number>(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      // Track if scrolled for condensed mode
      setIsScrolled(currentScroll > 50);

      // Always show the header - make it sticky when scrolled
      if (currentScroll > 50) {
        setIsSticky(true);
        setIsVisible(true);
      } else {
        // At top, still visible but not sticky
        setIsSticky(false);
        setIsVisible(true);
      }

      lastScrollY.current = currentScroll;
    };

    // Initial check on mount
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const handleSubmit = (e: React.FormEvent) => e.preventDefault();

  return (
    <header
      id="xb-header-area"
      className="header-area header-style--one header-transparent is-sticky glassmorphism-header"
    >
      <div
        className={`xb-header xb-sticky-stt glassmorphism-nav ${isSticky ? "xb-header-area-sticky" : ""
          } glassmorphism-visible ${isScrolled ? "glassmorphism-condensed" : "glassmorphism-fullwidth"
          }`}
      >
        <div className={`glassmorphism-container ${isScrolled ? "glassmorphism-condensed-container" : "glassmorphism-fullwidth-container"}`}>
          <div className="header__wrap ul_li_between">
            {/* Logo */}
            <div className="xb-header-logo">
              <Link to="/" className="logo1" onClick={handleClick}>
                <img src={logo} alt="Logo" />
              </Link>
            </div>

            {/* Desktop Menu */}
            <div className="main-menu__wrap navbar navbar-expand-lg p-0">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  {/* <li >
                    <Link to="/" onClick={handleClick}>
                      <span>Home</span>
                    </Link>
                  </li> */}



                  <li className="menu-item-has-children megamenu">
                    <Link to="#" onClick={handleClick}>
                      <span>Services</span>
                    </Link>
                    <MegaMenuServices />
                  </li>
                  <li className="menu-item-has-children megamenu">
                    <Link to="#" onClick={handleClick}>
                      <span>Solutions</span>
                    </Link>
                    <MegaMenuSolutions />
                  </li>

                  {/* MegaMenu */}
                  <li className="menu-item-has-children megamenu">
                    <Link to="#" onClick={handleClick}>
                      <span>Products</span>
                    </Link>
                    <MegaMenu1 />
                  </li>

                  <li>
                    <Link to="/about-us" onClick={handleClick}>
                      <span>About Us</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/corporate-social-responsibility" onClick={handleClick}>
                      <span>CSR</span>
                    </Link>
                  </li>

                  {/*  Careers */}
                  <li >
                    <Link to="/careers" onClick={handleClick}>
                      <span>Careers</span>
                    </Link>
                  </li>

                  <li>
                    <a
                      href="https://blog.aquarlabs.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={handleClick}
                    >
                      <span>Blog</span>
                    </a>
                  </li>

                  <li>
                    <Link to="/contact-us" onClick={handleClick}>
                      <span>Contact Us</span>
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>

            {/* Button */}
            <div className="header-btn">
              <Link to="/contact-us" className="thm-btn" onClick={handleClick}>
                Schedule a Demo
              </Link>
            </div>

            {/* Mobile Toggle */}
            <div className="header-bar-mobile side-menu d-lg-none">
              <button
                className="xb-nav-mobile"
                onClick={() => setMobileActive(!mobileActive)}
              >
                <i className="far fa-bars"></i>
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          <div className="xb-header-wrap" >
            <div className={`xb-header-menu ${mobileActive ? "active" : ""}`}>
              <div className="xb-header-menu-scroll">
                <div
                  className="xb-menu-close xb-hide-xl xb-close"
                  onClick={() => setMobileActive(false)}
                ></div>

                <div className="xb-logo-mobile xb-hide-xl">
                  <Link to="/" rel="home">
                    <img src={logo} alt="Logo" />
                  </Link>
                </div>

                {/* <div className="xb-header-mobile-search xb-hide-xl">
                  <form role="search" onSubmit={handleSubmit}>
                    <input
                      type="text"
                      placeholder="Search..."
                      name="s"
                      className="search-field"
                    />
                    <button className="search-submit" type="submit">
                      <i className="far fa-search"></i>
                    </button>
                  </form>
                </div> */}

                <nav className="xb-header-nav">
                  <MobileMenu />
                </nav>
              </div>
            </div>
            <div className="xb-header-menu-backdrop"></div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
